export const PRODUCTION_RESULTS_MONITORING_AT_MOBILE = `
    query productionResultsMonitoringAtMobile {
        productionResultsMonitoringAtMobile {
            site
            compCd
            goodQty
            defectQty
            defectRate
            productId
            materialName
        }
    }
`;